import React from 'react';

import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import ColoredButton from 'components/ColoredButton';
import Loader from 'components/Loader';
import TextButton from 'components/TextButton/TextButton';
import type { DpiaHistoryListItem } from 'config/api/dpiaRequests/dpiaRequests.types';
import general_messages from 'messages/general_messages';
import processing_activities_messages from 'messages/processing_activities_messages';

import DpiaHistoryList from './DpiaHistoryList';
import useDpiaHistory from './useDpiaHistory';

type Props = {
  canOpenAssessments?: boolean;
  apaId?: number;
  onClose: () => void;
  onOpenItem: (item: DpiaHistoryListItem) => void;
  open: boolean;
  organizationId?: number;
};

const DpiaHistoryDialog: React.FC<Props> = ({ apaId, onClose, onOpenItem, open, organizationId, canOpenAssessments = false }) => {
  const { t } = useTranslation();
  const messages = processing_activities_messages.asset_ropa.dpia_history;
  const { history, isError, isLoading, isUnavailable, refetch } = useDpiaHistory({
    apaId,
    enabled: open,
    organizationId,
  });

  return (
    <Dialog fullWidth maxWidth='sm' onClose={onClose} open={open}>
      <DialogTitle>{t(messages.dialog_title)}</DialogTitle>
      <DialogContent>
        {isLoading && <Loader inner />}
        {(isError || isUnavailable) && (
          <Typography color='error' variant='body2'>
            {t(processing_activities_messages.asset_ropa.errors.load_failed)}
            <TextButton onClick={() => refetch()}>{t(general_messages.retry)}</TextButton>
          </Typography>
        )}
        {history && <DpiaHistoryList canOpenAssessments={canOpenAssessments} items={history.items} onOpenItem={onOpenItem} />}
      </DialogContent>
      <DialogActions>
        <ColoredButton
          className=''
          customColor='grey'
          disabled={false}
          icon={false}
          onClick={onClose}
          showLoader={false}
          textLike={false}
          variant='outlined'
        >
          {t(general_messages.close)}
        </ColoredButton>
      </DialogActions>
    </Dialog>
  );
};

export default DpiaHistoryDialog;
